import { render, staticRenderFns } from "./TarfBenReview.vue?vue&type=template&id=74818f3a&"
import script from "./TarfBenReview.vue?vue&type=script&lang=js&"
export * from "./TarfBenReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports